import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #f9cacd;
`
const st1 = css`
  fill: #ffefe1;
`
const st2 = css`
  fill: #273e4f;
`

class ReserveAmenity extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M59.8,58.5H39.8L21.4,74.7l5.7,3.2v3.3l45.8-0.8l3-3.3l2.7-3.7L59.8,58.5z M68.4,42.4l-4.2-4.3 c0,0-2.9,3.8-14.3,3.8s-15-4.3-15-4.3l-3.3,5c0,0,7.1,4.5,19.3,4.5C63.2,47.1,68.4,42.4,68.4,42.4z'
        />
        <path
          css={st1}
          d='M19.3,75.7V29.4c2-1.4,3.3-3.8,3.3-6.4c0-4.4-3.5-7.9-7.9-7.9S6.7,18.6,6.7,23c0,2.7,1.4,5.1,3.4,6.5v46.2 c-4.6,0.7-7.8,2.6-7.8,4.7c0,2.8,5.5,5,12.4,5c6.8,0,12.4-2.3,12.4-5C27.1,78.3,23.9,76.5,19.3,75.7z M90,75.8V29.4 c2-1.4,3.3-3.8,3.3-6.4c0-4.4-3.5-7.9-7.9-7.9s-7.9,3.5-7.9,7.9c0,2.6,1.2,4.9,3.1,6.3v46.4c-4.5,0.8-7.7,2.6-7.7,4.7 c0,2.8,5.5,5,12.4,5c6.8,0,12.4-2.3,12.4-5C97.7,78.3,94.5,76.5,90,75.8z M24.8,33.7c-1.5,2.1-1,4.4,0.8,5.7l5.2,3.9l4.9-6.6 l-5.2-3.9C28.7,31.5,26.3,31.6,24.8,33.7z M75.2,33.7c-1.5-2.1-3.9-2.2-5.7-0.8l-5.2,3.9l4.9,6.6l5.2-3.9 C76.2,38.1,76.8,35.8,75.2,33.7z'
        />
        <path
          css={st2}
          d='M91.7,73.5V35h4.7c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8h-4.7V31c2.4-1.9,3.9-4.8,3.9-8 c0-5.6-4.6-10.2-10.2-10.2c-5.6,0-10.2,4.6-10.2,10.2c0,3.3,1.5,6.1,3.9,8v0.5h-3.6c-0.8-0.7-1.8-1.1-2.8-1.2 c-1.5-0.2-2.9,0.3-4.2,1.2l-5.2,3.9c-0.5,0.4-0.7,1-0.7,1.6c-1.7,0.8-5.6,2.3-12.5,2.3c-6.9,0-10.9-1.4-12.6-2.3c0-0.1,0-0.3,0-0.4 c-0.1-0.5-0.3-0.9-0.7-1.1l-5.2-3.9c-1.3-0.9-2.8-1.4-4.2-1.2c-1,0.1-2,0.6-2.8,1.2H21V31c2.4-1.9,3.9-4.8,3.9-8 c0-5.6-4.6-10.2-10.2-10.2C9,12.8,4.4,17.4,4.4,23c0,3.3,1.5,6.1,3.9,8v0.5H3.7c-1,0-1.8,0.8-1.8,1.8S2.7,35,3.7,35h4.7v38.5 C3.6,74.6,0,76.7,0,80c0,4.7,7.4,7.2,14.7,7.2c5.6,0,11.2-1.4,13.5-4.2h43.7c2.3,2.8,7.9,4.2,13.5,4.2c7.3,0,14.7-2.5,14.7-7.2 C100,76.7,96.4,74.6,91.7,73.5z M78.6,23c0-3.7,3-6.7,6.7-6.7s6.7,3,6.7,6.7c0,0.8-0.1,1.6-0.4,2.3c-0.6,1.7-1.9,3.1-3.5,3.8 c-0.9,0.4-1.8,0.6-2.8,0.6c-1,0-2-0.2-2.8-0.6c-1.6-0.7-2.9-2.1-3.5-3.8C78.8,24.6,78.6,23.8,78.6,23z M88.2,35v40.6h-5.6V35H88.2z M70.5,34.3c0.5-0.4,1.2-0.6,1.7-0.5c0.6,0.1,1.1,0.4,1.6,1c1.3,1.7,0,3-0.5,3.3l-3.8,2.8l-2.8-3.8L70.5,34.3z M35.5,39.8 c2,1,6.6,2.8,14.5,2.8c7.9,0,12.4-1.7,14.4-2.8l1.7,2.3c-2.2,1.3-7.3,3.4-16,3.4c-8.7,0-13.9-2.1-16.2-3.4L35.5,39.8z M26.1,34.7 c0.4-0.6,1-0.9,1.6-1c0.1,0,0.1,0,0.2,0c0.5,0,1,0.2,1.5,0.5l3.8,2.8l-2.8,3.8L26.6,38C26.1,37.7,24.8,36.5,26.1,34.7z M22.2,35 c-0.5,2.1,0.3,4.4,2.3,5.8l5.2,3.9c0.3,0.2,0.7,0.3,1,0.3c0.3,0,0.6-0.1,0.8-0.2C34.1,46.3,40,49,50,49c10,0,15.8-2.7,18.3-4.1 c0.3,0.1,0.5,0.2,0.8,0.2c0.4,0,0.7-0.1,1-0.3l5.2-3.9c2-1.5,2.8-3.7,2.3-5.8H79v36.3L61.1,56.9c-0.3-0.2-0.7-0.4-1.1-0.4H40 c-0.4,0-0.8,0.1-1.1,0.4L21,71.3V35H22.2z M7.9,23c0-3.7,3-6.7,6.7-6.7s6.7,3,6.7,6.7c0,0.8-0.1,1.6-0.4,2.3 c-0.6,1.7-1.9,3.1-3.5,3.8c-0.9,0.4-1.8,0.6-2.8,0.6c-1,0-2-0.2-2.8-0.6C10.2,28.4,9,27,8.3,25.3C8.1,24.6,7.9,23.8,7.9,23z M17.5,35v40.6h-5.6V35H17.5z M14.7,83.7c-6.9,0-11.2-2.4-11.2-3.7c0-0.8,1.8-2.1,4.8-2.9v0.2c0,1,0.8,1.8,1.8,1.8h9.1 c1,0,1.8-0.8,1.8-1.8v-0.2c3.1,0.8,4.8,2.1,4.8,2.9C25.8,81.3,21.6,83.7,14.7,83.7z M23.1,74.1L40.6,60h18.8l17.6,14.1 c-3.4,1.1-5.9,2.9-6.2,5.4H29.3C28.9,77,26.4,75.2,23.1,74.1z M85.3,83.7c-6.9,0-11.2-2.4-11.2-3.7c0-0.8,1.8-2.1,4.8-2.9v0.2 c0,1,0.8,1.8,1.8,1.8h9.1c1,0,1.8-0.8,1.8-1.8v-0.2c3.1,0.8,4.8,2.1,4.8,2.9C96.5,81.3,92.3,83.7,85.3,83.7z'
        />
      </svg>
    )
  }
}

ReserveAmenity.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { ReserveAmenity }
